import { useRef, useState } from 'react';
import backgroundImageUrl from "../images/15.png";
import mobilebackgroundImageUrl from "../images/21.png";
import transformationImageUrl from "../images/16.png";
import healingImageUrl from "../images/17.png";
import Footer from '../components/Footer';
import { FaArrowRight, FaMailBulk } from 'react-icons/fa';
import Header from '../components/Header';
import awardImage from "../images/18.png";
import learnMoreImage from "../images/19.png";
import mail from "../images/mail.png";
import Testimonials from '../components/Testimonials';
import {
    FaFacebook,
    FaInstagram,
    FaLinkedin,
} from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import EmailComponent from '../components/EmailComponent';
import { Bounce, toast } from 'react-toastify';
import BellComponent from '../components/BellComponent';
function Contact() {
    const form = useRef();
    const [loading, setLoading] = useState(false);
    const sendEmail = (e) => {
        e.preventDefault();
        setLoading(true);
        emailjs
            .sendForm('service_1nsk4kr', 'template_ylq8jqp', form.current, {
                publicKey: 'vm0yy7EL7qssyT0RL',
            })
            .then(
                () => {
                    setLoading(false);
                    form.current.reset();
                    toast.success('Thanks For Contacting Us', {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                        transition: Bounce,
                    });
                },
                (error) => {
                    setLoading(false);
                    toast.error('An Error Occurred, Please try again', {
                        position: "bottom-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                        transition: Bounce,
                    });
                },
            );
    };
    return (
        <div className="mb-[120px] md:mb-0">
            <Header pageName="Contact Us" />
            <div className="background-with-image-blue pt-32 hidden md:block"></div>
            <div className="background-with-image-blue">
                <div className="container mx-auto py-16 pt-32 px-8 ">
                    <section className="flex flex-col md:flex-row items-center justify-end text-white">
                        <div className="w-full md:w-1/2 md:pr-12">
                            <BellComponent isWhite={true} isLeft={true} />
                            <h2 className="eb-garamond text-center text-3xl font-serif mb-8 mt-4 md:mt-8 md:leading-relaxed max-w-prose flex justify-center"> 
                                    <FaMailBulk className='mt-1 md:mt-3 mr-4'/> <span></span>iram@iramkhokher.com
                            </h2>
                        </div>
                        <div className="w-full md:w-1/2">
                            <h2 className="poppins text-3xl font-serif mb-8 md:leading-relaxed max-w-prose uppercase text-center">
                                To receive <br className='block md:hidden'/>program material
                            </h2>
                            <div className="w-full flex flex-col gap-5 mt-8 md:mt-0 mx-auto">
                                <form ref={form} onSubmit={sendEmail}>
                                    <input className='w-full mb-5 p-4 text-black poppins rounded' placeholder='Enter Name' name="user_name" required />
                                    <input type='email' className='w-full mb-5 p-4 text-black poppins rounded' placeholder='Enter Email' name="user_email" required />
                                    {/* <input className='w-full mb-5 p-4 text-black poppins rounded' placeholder='Enter Phone Number' required /> */}
                                    <textarea className='w-full mb-5 p-4 text-black poppins min-h-[200px] rounded' placeholder='Enter Message' name="message" required></textarea>
                                    <button type='submit' className='submit-button w-full font-semibold text-lg rounded-full text-[#f15d16] hover:text-white border-2 border-white bg-white hover:bg-[transparent] poppins transition duration-300 py-2'>
                                        {loading ? (
                                            <span className="loader"></span>
                                        ) : (
                                            "Send Message"
                                        )} </button>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default Contact;